<table *ngIf="items" class="shadow-sm rounded rounded-1">
  <thead class="bg-secondary text-white">
    <tr>
      <th
        *ngFor="let header of headers"
        [style.width]="header.width"
        class="p-2"
        (click)="onSortColumn(header)"
      >
        {{ header.label }}

        <span *ngIf="header.sortable" class="sort-arrow">
          <span
            class="arrow"
            [ngClass]="{
              'arrow-up': sortColumn === header.key && sortDirection === 'asc',
              'arrow-down':
                sortColumn === header.key && sortDirection === 'desc',
              neutral: isNeutral(header)
            }"
          ></span>
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="rowTemplate; else defaultRowTemplate">
      <tr *ngFor="let item of items">
        <ng-container
          *ngTemplateOutlet="rowTemplate; context: { $implicit: item }"
        ></ng-container>
      </tr>
    </ng-container>
    <ng-template #defaultRowTemplate>
      <tr *ngFor="let item of items">
        <td *ngFor="let header of headers">{{ item[header.key] }}</td>
      </tr>
    </ng-template>
  </tbody>
</table>
